import { Api } from '@automapa/svelte-automapa-template';
import { JobResponseSchema } from '../Jobs/types';
import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
import { z } from 'zod';
import { JobServiceAttributesSchema } from '../Jobs/types';
import { QueriesTypeSchema, type QueriesType } from '../telematics/types';

export const AssignmentJobRejectionResponseSchema = z.object({
    job_id: z.number(),
    job: JobResponseSchema.optional(),
    assignment_id: z.number(),
    driver_info: z
        .object({
            unhandled: z.boolean().catch(false),
            webuser_id: z.number().catch(0),
            service_attributes: JobServiceAttributesSchema.optional(),
        })
});
export type AssignmentJobRejectionResponseType = z.infer<typeof AssignmentJobRejectionResponseSchema>;

export class AssignmentJobRejectionApi {

    public static async getByAssignmentId(api: Api, assignmentId: number): Promise<AssignmentJobRejectionResponseType[]> {
        return api.getData<QueriesType, AssignmentJobRejectionResponseType[]>(
            'post',
            '/assignment_job_rejections/query' +
                new ApiFilterBuilder(null)
                    .addRelation('job*')
                    .sortBy(null, null)
                    .getUri(),
            {
                assignment_id: assignmentId,
                driver_info: 'not_null',
                $or: [
                    {'job.completed_as_planned': null},
                    {'job.completed_as_planned': {$column: 'assignment_job_rejection.day'}}
                ]
            },
            QueriesTypeSchema,
            z.array(AssignmentJobRejectionResponseSchema)
        );
    }

    public static async getUnhandledByDay(api: Api, day: string): Promise<AssignmentJobRejectionResponseType[]> {
        return api.getData<QueriesType, AssignmentJobRejectionResponseType[]>(
            'post',
            '/assignment_job_rejections/query' +
                new ApiFilterBuilder(null)
                    .addRelation('job*')
                    .sortBy(null, null)
                    .getUri(),
            {
                day: {$lte: day},
                'job.rejected': true,
                driver_info: 'not_null',
                assignment_id: {$column: 'job.rejected_assignments.-1::int'},
                $or: [
                    {'job.completed_as_planned': null},
                    {'job.completed_as_planned': {$column: 'assignment_job_rejection.day'}}
                ]
            },
            QueriesTypeSchema,
            z.array(AssignmentJobRejectionResponseSchema)
        );
    }

}